import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import "./LogoCard.scss";

const tileStyles = {
	horizontal: "horizontal_card",
	vertical: "vertical_card",
};

const tileAlignment = {
	left: "left_aligned",
	center: "center_aligned",
};

const tileSizes = {
	large: "large_card",
	small: "small_card",
};

const Tile = ({
	styleName = "horizontal",
	alignment = "left",
	size,
	logoUrl,
	logoAlt = "",
	logoText,
	title,
	description,
	backgroundImage,
}) => {
	const [isVisible, setIsVisible] = useState(false);
	const tileRef = useRef(null);

	useEffect(() => {
		const observer = new IntersectionObserver(
			([entry]) => {
				if (entry.isIntersecting) {
					setIsVisible(true);
					observer.disconnect();
				}
			},
			{ threshold: 0.2 }
		);

		if (tileRef.current) observer.observe(tileRef.current);

		return () => observer.disconnect();
	}, []);

	const styleClass = tileStyles[styleName] || tileStyles.horizontal;
	const alignmentClass = tileAlignment[alignment] || tileAlignment.left;
	const sizeClass = tileSizes[size] || tileSizes;

	return (
		<div
			ref={tileRef}
			style={{
				backgroundImage: `url(${backgroundImage})`,
				backgroundSize: "contain",
				backgroundPosition: "center",
				backgroundRepeat: "no-repeat",
			}}
			className={`tile_container ${styleClass} ${alignmentClass} ${sizeClass} ${
				isVisible ? "visible" : ""
			}`}>
			<div className="logo_container">
				{logoUrl && (
					<img src={logoUrl} alt={logoAlt} className="tile_logo" />
				)}
				{logoText && <div className="tile_logo_text">{logoText}</div>}
			</div>
			<div className="tile_content">
				{title && <h3 className="tile_title">{title}</h3>}
				{description && (
					<p className="tile_description">{description}</p>
				)}
			</div>
		</div>
	);
};

Tile.propTypes = {
	styleName: PropTypes.oneOf(["horizontal", "vertical"]),
	alignment: PropTypes.oneOf(["left", "center"]),
	logoUrl: PropTypes.string,
	logoAlt: PropTypes.string,
	logoText: PropTypes.string,
	title: PropTypes.string,
	description: PropTypes.string,
	size: PropTypes.oneOf(["large", "small"]),
};

export default Tile;
